/* Independent custom elements also initialise on Shopify section reloads. */
if (!customElements.get('tn-home-typewriter')) {
  customElements.define('tn-home-typewriter', class extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-typed]');
      this.control = this.querySelector('[data-motion]');
      try { this.phrases = JSON.parse(this.dataset.phrases).filter(p => p.trim()); } catch { this.phrases = []; }
      if (!this.output || this.phrases.length < 2 || this.dataset.enabled !== 'true') return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      this.index = 0; this.deleting = true; this.userPaused = false;
      this.output.textContent = this.phrases[0];
      this.control.hidden = false;
      this.control.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.control.setAttribute('aria-pressed', String(this.userPaused));
        this.control.setAttribute('aria-label', this.userPaused ? 'Play text animation' : 'Pause text animation');
        this.sync();
      }, { signal: this.abort.signal });
      this.motion.addEventListener('change', () => this.sync(), { signal: this.abort.signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal: this.abort.signal });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
      this.observer.observe(this);
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.control.hidden = this.motion.matches;
      if (this.motion.matches) { this.output.textContent = this.phrases[0]; this.index = 0; this.deleting = true; return; }
      if (this.userPaused) { this.output.textContent = this.phrases[this.index]; this.deleting = true; return; }
      if (document.hidden || this.visible === false) return;
      this.timer = setTimeout(() => this.tick(), 2300);
    }
    tick() {
      const phrase = this.phrases[this.index];
      const length = Array.from(this.output.textContent).length;
      let delay;
      if (this.deleting) {
        this.output.textContent = Array.from(phrase).slice(0, Math.max(0, length - 1)).join('');
        delay = 35;
        if (length <= 1) { this.deleting = false; this.index = (this.index + 1) % this.phrases.length; delay = 180; }
      } else {
        this.output.textContent = Array.from(phrase).slice(0, length + 1).join('');
        delay = 75;
        if (length + 1 >= Array.from(phrase).length) { this.deleting = true; delay = 2900; }
      }
      this.timer = setTimeout(() => this.tick(), delay);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
  });
}

if (!customElements.get('tn-home-tabs')) {
  customElements.define('tn-home-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.tablist = this.querySelector('[data-tabs]');
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.abort = new AbortController();
      this.tablist.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].tabIndex = 0;
        tab.addEventListener('click', event => { event.preventDefault(); this.select(index); }, { signal: this.abort.signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); this.select(next); this.tabs[next].focus();
        }, { signal: this.abort.signal });
      });
      const initial = this.panels.findIndex(panel => '#' + panel.id === location.hash);
      this.select(Math.max(initial, 0));
    }
    select(index) {
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; this.panels[i].hidden = i !== index; });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
